import type { RootState } from '@/store/store'
import type { ActivityFeedRow } from '../schemas'
import { kStaleActivityTimestamp } from './slice'

/* Shared empty list, so a matter with nothing cached returns a stable reference. */
const kNoRows: ActivityFeedRow[] = []

export function selectMatterActivityRows(state: RootState, matterId: string): ActivityFeedRow[] {
  return state.matterActivityFeedState.byMatterId[matterId]?.rows ?? kNoRows
}

/** True when the matter has activity beyond what was fetched. */
export function selectMatterActivityHasMore(state: RootState, matterId: string): boolean {
  return state.matterActivityFeedState.byMatterId[matterId]?.hasMore ?? false
}

export function selectMatterActivityLoading(state: RootState, matterId: string): boolean {
  return state.matterActivityFeedState.byMatterId[matterId]?.isLoading ?? false
}

export function selectMatterActivityError(state: RootState, matterId: string): boolean {
  return state.matterActivityFeedState.byMatterId[matterId]?.isError ?? false
}

/** True once a fetch has completed for the matter, whether or not it returned any rows. */
export function selectMatterActivityInitialLoadComplete(state: RootState, matterId: string): boolean {
  return state.matterActivityFeedState.byMatterId[matterId]?.initialLoadComplete ?? false
}

/** True once something has invalidated the matter's cached rows, so a mounted feed can refetch them. */
export function selectMatterActivityStale(state: RootState, matterId: string): boolean {
  return state.matterActivityFeedState.byMatterId[matterId]?.lastRefresh === kStaleActivityTimestamp
}
